import { CustomerGroup } from '@vend/types'

export interface CustomerInfo {
  [CUSTOMER_NAME_FIELD.FIRSTNAME]?: string
  [CUSTOMER_NAME_FIELD.LASTNAME]?: string
  [CONTACT_OPTIONS.EMAIL]?: string
  [CONTACT_OPTIONS.MOBILE]?: string
  [CONTACT_OPTIONS.PHONE]?: string
  [CONTACT_OPTIONS.FAX]?: string
  [CUSTOMER_FIELD.GROUP]?: PartialCustomerGroup
}

export enum CONTACT_OPTIONS {
  MOBILE = 'mobile',
  PHONE = 'phone',
  FAX = 'fax',
  EMAIL = 'email',
}

export enum CUSTOMER_NAME_FIELD {
  FIRSTNAME = 'firstName',
  LASTNAME = 'lastName',
}
// Other fields can be added as needed
export enum CUSTOMER_FIELD {
  GROUP = 'group',
}

export type PartialCustomerGroup = Pick<CustomerGroup, 'id' | 'name'> &
  Partial<CustomerGroup>

export enum SOURCE_MODAL {
  // add quotes, unfulfilled sales etc. as needed
  SERVICE = 'service',
}
